import React from 'react';
import { IMAGES } from '../constants/images';
import { FiCheck, FiArrowRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import useIsMobile from '../utils/useIsMobile';

const highlights = [
  'Installation scheduled with your provider',
  'Responsive sales & enrollment help',
  'Upfront quotes — pricing varies by provider',
  'Trusted provider partners',
];

const About = () => {
  const isMobile = useIsMobile(768);
  const isTablet = useIsMobile(1100);

  return (
    <section style={{ padding: 'clamp(40px, 7vw, 100px) var(--cc-px)', background: '#fff', fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>
      <div className="max-content-width" style={{ width: '100%' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(280px, 100%), 1fr))', gap: 'clamp(32px, 5vw, 64px)', alignItems: 'center' }}>

          {/* Image side */}
          <div style={{ position: 'relative', paddingTop: isMobile ? 16 : 0, paddingLeft: isMobile ? 0 : 0 }}>
            <div style={{ borderRadius: 24, overflow: 'hidden', aspectRatio: '4/3', boxShadow: '0 24px 64px rgba(0,0,0,0.12)' }}>
              <img
                src={IMAGES.about}
                alt="Colleagues collaborating"
                style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }}
                loading="lazy"
              />
            </div>

            {/* Floating experience badge */}
            <div style={{
              position: 'absolute',
              bottom: isMobile ? -14 : isTablet ? -14 : -18,
              right: isMobile ? 8 : isTablet ? 8 : -18,
              background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
              borderRadius: 18, padding: '18px 22px', textAlign: 'center',
              boxShadow: '0 10px 32px rgba(37,99,235,0.4)',
            }}>
              <p style={{ color: '#fff', fontWeight: 900, fontSize: '1.3rem', margin: 0, lineHeight: 1 }}>Our</p>
              <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.8rem', margin: '4px 0 0', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700 }}>Experience</p>
            </div>

            {/* Floating customers badge */}
            <div style={{
              position: 'absolute',
              top: isMobile ? 4 : isTablet ? 4 : -14,
              left: isMobile ? 8 : isTablet ? 8 : -14,
              background: '#fff', borderRadius: 16, padding: '14px 18px',
              boxShadow: '0 8px 28px rgba(0,0,0,0.12)',
              border: '1.5px solid #e8edf5',
              display: 'flex', alignItems: 'center', gap: 10,
            }}>
              <span style={{ fontSize: '1.4rem' }}>🏆</span>
              <div>
                <p style={{ fontWeight: 900, color: '#0f172a', fontSize: '0.97rem', margin: 0, lineHeight: 1 }}>All Over USA</p>
                <p style={{ color: '#64748b', fontSize: '0.7rem', margin: '3px 0 0', fontWeight: 600 }}>Service Region</p>
              </div>
            </div>
          </div>

          {/* Text side */}
          <div>
            <span style={{ fontSize: '0.75rem', fontWeight: 700, color: '#2563eb', letterSpacing: '0.1em', textTransform: 'uppercase', display: 'block', marginBottom: 12 }}>Who We Are</span>
            <h2 style={{ fontSize: 'clamp(1.9rem, 3vw, 4.5rem)', fontWeight: 900, color: '#0f172a', lineHeight: 1.12, letterSpacing: '-0.02em', margin: '0 0 20px' }}>
              Trusted Connectivity<br />
              <span style={{ color: '#2563eb' }}>for Homes &amp; Businesses</span>
            </h2>

            {/* Accent quote bar */}
            <div style={{ borderLeft: '4px solid #2563eb', paddingLeft: 20, marginBottom: 24 }}>
              <p style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: 700, lineHeight: 1.85, margin: 0, fontStyle: 'italic' }}>
                "We help you compare and enroll in Internet, Cable TV, Wi‑Fi, and Wireless plans with upfront quotes, clear guidance, and responsive sales & enrollment help."
              </p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 28 }}>
              <p style={{ color: '#334155', lineHeight: 1.85, margin: 0, fontSize: '1.02rem' }}>
                InternetTVService is an Authorized Dealer for Internet and TV services. We're a dedicated team focused on connectivity — we compare provider plans, coordinate installation, and guide you through enrollment and setup so you get the right service without the hassle. Ongoing technical service is handled by your provider.
              </p>
              <p style={{ color: '#334155', lineHeight: 1.85, margin: 0, fontSize: '1.02rem' }}>
                We prioritize transparent, needs-based recommendations and practical sales & enrollment help for customers across the USA.
              </p>
            </div>

            {/* Highlights */}
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 10, marginBottom: 36 }}>
              {highlights.map((h, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span style={{ width: 22, height: 22, borderRadius: '50%', background: '#dbeafe', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <FiCheck style={{ width: 12, height: 12, color: '#2563eb' }} />
                  </span>
                  <span style={{ color: '#0f172a', fontSize: '0.95rem', fontWeight: 600 }}>{h}</span>
                </div>
              ))}
            </div>

            <Link to="/about" style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              background: 'linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)',
              color: '#fff', fontWeight: 700, fontSize: '0.95rem',
              padding: '13px 26px', borderRadius: 999, textDecoration: 'none',
              boxShadow: '0 4px 18px rgba(37,99,235,0.35)',
              transition: 'opacity 0.2s, transform 0.15s',
            }}
            onMouseEnter={e => { e.currentTarget.style.opacity = '0.9'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              Learn More About Us <FiArrowRight style={{ width: 15, height: 15 }} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
